/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    B2cUser,
    B2cUserFromJSON,
    B2cUserToJSON,
    B2cUserAttribute,
    B2cUserAttributeFromJSON,
    B2cUserAttributeToJSON,
    B2cUsersResult,
    B2cUsersResultFromJSON,
    B2cUsersResultToJSON,
    CopyUserPermissionsRequest,
    CopyUserPermissionsRequestFromJSON,
    CopyUserPermissionsRequestToJSON,
    GlobalPermissions,
    GlobalPermissionsFromJSON,
    GlobalPermissionsToJSON,
    UserPermissionsConfiguration,
    UserPermissionsConfigurationFromJSON,
    UserPermissionsConfigurationToJSON,
    UserPermissionsFormData,
    UserPermissionsFormDataFromJSON,
    UserPermissionsFormDataToJSON,
    UserPermissionsValidationErrors,
    UserPermissionsValidationErrorsFromJSON,
    UserPermissionsValidationErrorsToJSON,
} from '../models';

export interface ApiUserPermissionsCopyUserPermissionsPostRequest {
    copyUserPermissionsRequest?: CopyUserPermissionsRequest;
}

export interface ApiUserPermissionsGetUserGetRequest {
    userId?: string;
}

export interface ApiUserPermissionsGetUsersGetRequest {
    filterType?: B2cUserAttribute;
    filterKeyword?: string;
    pageSize?: number;
    skipToken?: string;
}

export interface ApiUserPermissionsSetUserPermissionsPostRequest {
    userId?: string;
    userPermissionsFormData?: UserPermissionsFormData;
}

export interface ApiUserPermissionsValidatePostRequest {
    userPermissionsFormData?: UserPermissionsFormData;
}

/**
 * no description
 */
export class UserPermissionsApi extends runtime.BaseAPI {

    /**
     */
    async apiUserPermissionsCopyUserPermissionsPostRaw(requestParameters: ApiUserPermissionsCopyUserPermissionsPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/CopyUserPermissions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyUserPermissionsRequestToJSON(requestParameters.copyUserPermissionsRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserPermissionsCopyUserPermissionsPost(requestParameters: ApiUserPermissionsCopyUserPermissionsPostRequest): Promise<void> {
        await this.apiUserPermissionsCopyUserPermissionsPostRaw(requestParameters);
    }

    /**
     */
    async apiUserPermissionsGetConfigurationGetRaw(): Promise<runtime.ApiResponse<UserPermissionsConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/GetConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionsConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiUserPermissionsGetConfigurationGet(): Promise<UserPermissionsConfiguration> {
        const response = await this.apiUserPermissionsGetConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiUserPermissionsGetGlobalPermissionsGetRaw(): Promise<runtime.ApiResponse<GlobalPermissions>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/GetGlobalPermissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalPermissionsFromJSON(jsonValue));
    }

    /**
     */
    async apiUserPermissionsGetGlobalPermissionsGet(): Promise<GlobalPermissions> {
        const response = await this.apiUserPermissionsGetGlobalPermissionsGetRaw();
        return await response.value();
    }

    /**
     */
    async apiUserPermissionsGetUserGetRaw(requestParameters: ApiUserPermissionsGetUserGetRequest): Promise<runtime.ApiResponse<B2cUser>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/GetUser`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => B2cUserFromJSON(jsonValue));
    }

    /**
     */
    async apiUserPermissionsGetUserGet(requestParameters: ApiUserPermissionsGetUserGetRequest): Promise<B2cUser> {
        const response = await this.apiUserPermissionsGetUserGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiUserPermissionsGetUsersGetRaw(requestParameters: ApiUserPermissionsGetUsersGetRequest): Promise<runtime.ApiResponse<B2cUsersResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterType !== undefined) {
            queryParameters['filterType'] = requestParameters.filterType;
        }

        if (requestParameters.filterKeyword !== undefined) {
            queryParameters['filterKeyword'] = requestParameters.filterKeyword;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.skipToken !== undefined) {
            queryParameters['skipToken'] = requestParameters.skipToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/GetUsers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => B2cUsersResultFromJSON(jsonValue));
    }

    /**
     */
    async apiUserPermissionsGetUsersGet(requestParameters: ApiUserPermissionsGetUsersGetRequest): Promise<B2cUsersResult> {
        const response = await this.apiUserPermissionsGetUsersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiUserPermissionsSetUserPermissionsPostRaw(requestParameters: ApiUserPermissionsSetUserPermissionsPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/SetUserPermissions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPermissionsFormDataToJSON(requestParameters.userPermissionsFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserPermissionsSetUserPermissionsPost(requestParameters: ApiUserPermissionsSetUserPermissionsPostRequest): Promise<void> {
        await this.apiUserPermissionsSetUserPermissionsPostRaw(requestParameters);
    }

    /**
     */
    async apiUserPermissionsValidatePostRaw(requestParameters: ApiUserPermissionsValidatePostRequest): Promise<runtime.ApiResponse<UserPermissionsValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissions/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPermissionsFormDataToJSON(requestParameters.userPermissionsFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionsValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiUserPermissionsValidatePost(requestParameters: ApiUserPermissionsValidatePostRequest): Promise<UserPermissionsValidationErrors> {
        const response = await this.apiUserPermissionsValidatePostRaw(requestParameters);
        return await response.value();
    }

}
